import client from "@/lib/axios";
import { EditSettingsRequestPayload, SettingsSuccessResponse } from "../types";

export default {
  get: async () => {
    const response = await client.get<SettingsSuccessResponse>("/settings");

    return response.data;
  },
  edit: async (id: number | null, data: EditSettingsRequestPayload): Promise<SettingsSuccessResponse> => {
    const response = await client.put(`/settings/${id}`, data, {
      headers: {
        "Content-Type": "application/ld+json",
      },
    });

    return response.data;
  },
};
